import React from 'react';
import { Control } from 'react-hook-form';
import { EditableQuestion, StructuredInputType } from '../../../../../types';
import NumericLimitEditor from './NumericLimitEditor';
import { StyledEmptyCell } from './styles';

interface Props {
  control: Control<EditableQuestion>;
  toggleIndex: number;
  index: number;
  inputType?: StructuredInputType;
}

const LIMITS = [
  { key: 'decimals', placeholder: 'Decimals' },
  { key: 'min', placeholder: 'Min' },
  { key: 'max', placeholder: 'Max' },
] as const;

/**
 * The three numeric limits of a field. A text field has none — the api rejects them
 * there — but its columns are still held open so the row matches the headings.
 */
const FieldLimits = ({ control, toggleIndex, index, inputType }: Props) => {
  if (inputType === 'text') {
    return (
      <>
        {LIMITS.map(limit => (
          <StyledEmptyCell key={limit.key} aria-hidden />
        ))}
      </>
    );
  }

  return (
    <>
      {LIMITS.map(limit => (
        <NumericLimitEditor
          key={limit.key}
          control={control}
          name={`input.toggles.${toggleIndex}.fields.${index}.${limit.key}` as 'input.toggles.0.fields.0.min'}
          placeholder={limit.placeholder}
        />
      ))}
    </>
  );
};

export default FieldLimits;
